import React from 'react'
import PropTypes from 'prop-types'
import { PLAYBOOK_STEP_MAP } from 'utils/adminExperienceHelpers'
import TierLabel from 'components/TierLabel'
import {
  StyledHeaderTwo,
  SummaryLink,
  TierPill,
  TopWrapper,
} from '../component.styles'
import {
  HEADER_TEXT_DEFAULT,
  HEADER_TEXT_RECENT_ACTIVITIES,
  HEADER_TEXT_SUMMARY,
  SUMMARY_LINK_TEXT,
} from '../constants'

const PlaybookHeader = ({
  hasAllStepsCompleted,
  hasProgramStarted,
  onOpenSummaryModal,
  showMonitorViewOnly,
  showSummary,
}) => (
  <TopWrapper
    hasProgramStarted={hasProgramStarted}
    showMonitorViewOnly={showMonitorViewOnly}
  >
    <StyledHeaderTwo>
      {showMonitorViewOnly
        ? 'School Progress'
        : hasProgramStarted
        ? HEADER_TEXT_RECENT_ACTIVITIES
        : showSummary
        ? HEADER_TEXT_SUMMARY
        : HEADER_TEXT_DEFAULT}
    </StyledHeaderTwo>
    {!showMonitorViewOnly && (hasProgramStarted || hasAllStepsCompleted) && (
      <SummaryLink onClick={onOpenSummaryModal}>
        {SUMMARY_LINK_TEXT}
      </SummaryLink>
    )}
    {showMonitorViewOnly && (
      <TierPill>
        <TierLabel labelText={PLAYBOOK_STEP_MAP.tierLabel} />
      </TierPill>
    )}
  </TopWrapper>
)

PlaybookHeader.propTypes = {
  hasAllStepsCompleted: PropTypes.bool,
  hasProgramStarted: PropTypes.bool,
  onOpenSummaryModal: PropTypes.func,
  showMonitorViewOnly: PropTypes.bool,
  showSummary: PropTypes.bool,
}

export default PlaybookHeader
